import { buildWaitlistFunnelParams, type WaitlistFormLocation } from '@/wabunka-src/common/utils/googleAnalytics/common/waitlistFunnel';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

/**
 * 発火タイミング：ウェイトリストの登録ボタンが押された時（入力エラーで API を呼ばなかった時も送る）
 */
export const sendGAWabunkaWaitlistSubmitEvent = (experienceSlug: string, location: WaitlistFormLocation) => {
  sendWabunkaGAEvent('waitlist_submit', buildWaitlistFunnelParams(experienceSlug, location));
};
